import { Injectable } from '@angular/core';
import { DiagnosticOrderActionsService } from '@ispm/test/services/diagnostic-order-actions.service';
import { get, isEmpty } from 'lodash';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { AgregationService, BundleCall } from '@ispm-client/modules/aggregator/services';
import { Subject } from 'rxjs/Subject';
import {BehaviorSubject} from "rxjs/BehaviorSubject";

@Injectable()
export class GetModelContextService {
  private datamodelContext = new Subject<any>();
  datamodelContextObservable = this.datamodelContext.asObservable();

  private permission:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private parentChanges:Subject<any> = new Subject<any>();

  constructor(private diagnosticOrderActionsService: DiagnosticOrderActionsService,
              private _bundleCall: BundleCall,
              private _agregatorService: AgregationService,
              private http: HttpClient) {
  }

  setPermission(data: boolean) {
    this.permission.next(data);
  }

  public getPermission(): Observable<boolean> {
    return this.permission.asObservable();
  }

  setParentChanges(data: any) {
    this.parentChanges.next(data);
  }

  public getparentChanges(): Observable<any> {
    return this.parentChanges.asObservable();
  }

  dataModelContext(data: any) {
    if (data) {
      this.datamodelContext.next(data);
    }
  }

  getDatamodelAttributes(): Observable<any> {
    return this.diagnosticOrderActionsService.getState()
      .filter(state => !!state.order && Object.keys(state.order).length > 0)
      .take(1)
      .map(state => {
        const current = state.order;
        return current;
      });
  }

  public  getItemsBasedOnCondition(config: any): Observable<any> {
    let priority: number = 0;
    const itemBindings = config.filter(itemBindings => itemBindings.hasOwnProperty('responseUsed') && itemBindings.responseUsed === 'Configuration');
    priority++;
    return  this.fetchDataBasedOnPriority(itemBindings, priority, { });
  }

  fetchDataBasedOnPriority(completeBindings, priority, finalInterpolateObj = { }): Observable<any> {
    const currentBindings = completeBindings.filter(binding => {
      if (binding.priority === priority) {
        return true;
      }
    });
    return this._agregatorService.registerQuery(currentBindings).take(1)
      .switchMap( primaryData => {
        finalInterpolateObj = Object.assign(finalInterpolateObj, ...primaryData);
        priority++;
        const nextBindings = completeBindings.filter(binding => (binding.priority === priority));
        if (!isEmpty(nextBindings)) {
          nextBindings.forEach(nextBinding => {
            nextBinding.queryString = this._agregatorService.interpolate(nextBinding.queryString, finalInterpolateObj);
          });
          return this.fetchDataBasedOnPriority(completeBindings, priority, finalInterpolateObj);
        }
        else {
          priority = 0;
          return Observable.of(this.getValueBasedOnIdentifier(currentBindings, finalInterpolateObj));
        }
      });
  }

  getValueBasedOnIdentifier(dataBinding, responseValue) {
    let value = '';
    dataBinding.forEach(binding => {
      if (responseValue.hasOwnProperty(binding.identifier)) {
        value = get(responseValue, binding.identifier);
      }});
    return value;
  }

}
